import React from 'react';
import { FileCheck, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export const WannGutachten = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Nächster Schritt
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Wann ein Unfallgutachten sinnvoll sein kann
          </h2>
        </div>

        <div className="bg-white border border-gray-200 rounded-3xl p-10 lg:p-12 shadow-lg">
          <div className="flex items-start gap-6 mb-8">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center border border-brand-green/15">
                <FileCheck className="w-8 h-8 text-brand-green" />
              </div>
            </div>
            <div className="flex-1">
              <p className="text-gray-700 leading-relaxed text-lg mb-4">
                Ein unabhängiges Unfallgutachten kann hilfreich sein, wenn der Schaden über einen Bagatellschaden hinausgeht oder eine objektive Bewertung zur Durchsetzung von Ansprüchen erforderlich ist.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Es dokumentiert den Schaden umfassend, ermittelt Reparaturkosten, Wertminderung und weitere unfallbedingte Positionen. Die Entscheidung ist einzelfallabhängig.
              </p>
            </div>
          </div>

          <div className="border-t border-gray-100 pt-8 text-center">
            <p className="text-gray-600 mb-6 text-lg">
              Mehr Details zu Ablauf, Kosten und Voraussetzungen finden Sie hier:
            </p>
            <a href="/unfallgutachten">
              <Button size="lg" className="bg-brand-green hover:bg-brand-green-dark text-white text-lg px-10 py-6 rounded-2xl font-semibold">
                Mehr zum Unfallgutachten erfahren
                <ArrowRight className="w-5 h-5 ml-3" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};